import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { t } from 'app/core/i18n/i18n';

/**
 * Toolbar export button building block.
 * Emits click event for parent to handle export logic.
 *
 * @example
 * ```html
 * <app-toolbar-export-button
 *   (exportClick)="onExport()"
 *   label="Exportar"
 *   tooltip="Exportar datos a Excel"
 * />
 * ```
 */
@Component({
  selector: 'app-toolbar-export-button',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
  template: `
    <button
      mat-flat-button
      [color]="color"
      (click)="exportClick.emit()"
      [matTooltip]="tooltip"
      [disabled]="disabled"
    >
      <mat-icon svgIcon="heroicons_outline:document-arrow-down"></mat-icon>
      <span class="ml-2">{{ label }}</span>
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarExportButtonComponent {
  @Input() label = t('GENERAL.EXPORT');
  @Input() tooltip = t('routing.SUB_ROUTE_PARTNERS.TOOLBAR.EXPORT_BUTTON_DEFAULT_TOOLTIP');
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';
  @Input() disabled = false;

  @Output() exportClick = new EventEmitter<void>();
}
